$(function () {
  var header = $(".nav_wrapper");

  if (header.length) {
    if ($(window).width() > 767) {
      var sticky = header.offset().top;
    }else {
      var sticky = header.offset().top - 74;
    }

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.addClass("has_sticky");
        var sth = header.outerHeight();
      } else {
        header.removeClass("has_sticky");
      }

      setTimeout(function(){
        header.find('.nav-tabs').scrollingTabs('refresh');
      }, 200);
    }

    myFunction();
    $(window).on('scroll', myFunction)
  }

  $(document).on('click', '.size_guide_links .tab-link[data-tab]', function () {
    var tabd = $(this).data('tab');
    var id = $('#'+tabd).offset().top;
    var index = tabd.replace('tab-','');

    if ($('.core-classic-tab').length > 0) {
      $('.right-slider-items .class-sl-info').removeClass('active');
      $(this).closest('.core_classic_wrapper').find('.class-right-slider').slick('slickGoTo', parseInt(index - 1));
      $(this).closest('.core_classic_wrapper').find('.right-slider-items.'+tabd+' .class-sl-info').addClass('active');
    }

    $("html, body").animate({ scrollTop: id - 100 }, 1000);

    $(this).closest('.tabs-nav').find('.scrtabs-tab-container .tab-link').removeClass('current');
    $(this).addClass('current');

  })

  var btn = '.vid_play_page'
  var vid_btn = '#video_page'
  $(vid_btn)[0].controls = false
  $(vid_btn).click(function () {
    if (this.paused) {
      $(vid_btn)[0].play();
      $(btn).hide();
    } else {
      $(vid_btn)[0].pause();
      $(btn).show();
    }
  });

  $(btn).click(function (e) {
    e.preventDefault();
    $(btn).hide();
  });

  $(btn).on('click',function (e) {
    e.preventDefault();
    this.controls = false;
    $(vid_btn)[0].play();
  })
});

$(document).on('click', '.find-size-input .size-find-btn', function (e) {
  e.preventDefault()
  $(this).closest('.find-size-input').find('.err_msg').remove()
  if ($(this).closest('.input_wp').find('input').val() != '') {
    var val = parseInt($(this).closest('.input_wp').find('input').val());
    $(this).closest('.find-size').find('.find-size-right .reco-size .adult_size').remove();
    var adresult;
    var kidresult;
    var age;
    var kids;
    var msgerr;
    var adcnt = 0;
    var kidscnt = 0;
    if (val >= 50 && val <= 52){
      kids = 'Kids';
      kidresult = 'Small/Medium 19⅝ - 20½';
      kidscnt++;
    }else if (val >= 53 && val <= 54){
      kids = 'Kids';
      kidresult = 'Medium/Large 20½ - 21¼*';
      kidscnt++;
    }
    if (val >= 54 && val <= 55.4){
      age = 'Adult';
      adresult = 'X-Small 21 1/4*';
      adcnt++;
    }else if (val >= 55.5 && val <= 56){
      age = 'Adult';
      adresult = 'Small 21 5/8*';
      adcnt++;
    }else if (val >= 57 && val <= 58){
      age = 'Adult';
      adresult = 'Medium 22 1/2*';
      adcnt++;
    }else if (val >= 59 && val <= 60){
      age = 'Adult';
      adresult = 'Large 23 1/4*';
      adcnt++;
    }else if (val >= 61 && val <= 62){
      age = 'Adult';
      adresult = 'X-Large 24*';
      adcnt++;
    }else if (val >= 63){
      age = 'Adult';
      adresult = 'XX-Large 24 7/8*';
      adcnt++;
    }

    $(this).closest('.find-size').find('.find-size-right .reco-size h5').after('<div class="adult_size"></div>');
    if (adresult != null){
      $(this).closest('.find-size').find('.find-size-right .reco-size .adult_size').append('<span>'+ age +' size:</span><h2>'+adresult+'</h2>');
    }
    if (kidresult != null){
      $(this).closest('.find-size').find('.find-size-right .reco-size .adult_size').append('<span>'+ kids +' size:</span><h2>'+kidresult+'</h2>');
    }
    if (adresult == null && kidresult == null) {
      $(this)
        .closest('.find-size')
        .find('.find-size-right .reco-size .adult_size')
        .append('<h5 style="color: red;">Please add proper measurement</h5>');
    }
    $(this).closest('.find-size').addClass('find-my-size');
  } else {
    $(this).closest('.input_wp').after('<p class="err_msg">Please add some value</p>');
  }
});

$(document).on('click', '.find-size-left .click_up', function (e) {
  e.preventDefault();
  var att = $(this).attr('href');
  $('.sub_cont[data-tab="'+ att +'"]').trigger('click');
});

$(function () {
  function initialize_measure_head () {
    if ($(window).width() < 640) {
      $('.measure_head').not('.slick-initialize').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        infinite: false,
        arrows: true,
        adaptiveHeight: true,
        touchThreshold: 100,
        swipeToSlide: true,
        waitForAnimate: false,
        responsive: [
          {
            breakpoint: 640,
            settings: "unslick"
          }
        ],
      });
    }
  }

  $(window).on('resize', initialize_measure_head)
  initialize_measure_head()
})
